import { filter, reduce } from 'lodash/fp';
import { Identified } from '../types';
import { keyById } from '../utils';

export const filterByIds = <T extends Identified>(entities: T[], ids: string[]): T[] => {
    if(ids.length === 1) {
        const [id] = ids;
        return filter({ id }, entities) as T[];
    }
    const keyedEntities = keyById(entities);

    return reduce((acc: T[], curr) => {
        const entity = keyedEntities[curr];
        if(entity){
            acc.push(entity);
        }
        return acc;
    }, [], ids);


};